import type { Benefit } from '@/features/events';
import { OrnamentIcon } from '@/components/ornaments/OrnamentIcon';
import { cx } from '@/lib/cx';
import styles from './IconFeature.module.css';

export interface IconFeatureProps {
  benefit: Benefit;
  /** `column` icono arriba (mockups) · `row` icono a la izquierda. */
  layout?: 'column' | 'row';
  /** Filete vertical separador entre columnas, como en Buenos Aires y Miami. */
  divided?: boolean;
  className?: string;
}

/** Beneficio con ornamento: la fila de iconos que llevan las 5 landings. */
export function IconFeature({ benefit, layout = 'column', divided = false, className }: IconFeatureProps) {
  return (
    <div className={cx(styles.feature, styles[layout], divided && styles.divided, className)}>
      <OrnamentIcon name={benefit.icon} size={layout === 'column' ? 46 : 34} className={styles.icon} />
      <div className={styles.body}>
        <p className={styles.title}>{benefit.title}</p>
        {benefit.description ? <p className={styles.description}>{benefit.description}</p> : null}
      </div>
    </div>
  );
}
